// GSAP library
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function animateFrom(elem, direction) {
    direction = direction || 1;
    var x = 0,
        y = direction * 120;
    if (elem.classList.contains("gs_reveal_fromLeft")) {
        x = -120;
        y = 0;
    } else if (elem.classList.contains("gs_reveal_fromRight")) {
        x = 120;
        y = 0;
    }
    elem.style.transform = "translate(" + x + "px, " + y + "px)";
    elem.style.opacity = "0";
    gsap.fromTo(elem, { x: x, y: y, autoAlpha: 0 }, {
        duration: 1.25,
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: "expo",
        overwrite: "auto"
    });
}

function hide(elem) {
    gsap.set(elem, { autoAlpha: 0 });
}

function animateCounter(el) {
    const target = parseInt(el.dataset.counter);
    const obj = { value: 0 };

    gsap.to(obj, {
        value: target,
        duration: 1.5,
        ease: 'power2.out',
        onUpdate: function() {
            el.textContent = Math.floor(obj.value);
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger);

    var wideScreen = window.matchMedia("(min-width: 769px)");
    var narrowScreen = window.matchMedia("(max-width: 768px)");

    gsap.utils.toArray(".gs_reveal").forEach(function (elem) {
        if (wideScreen.matches) {
            hide(elem); // assure that the element is hidden when scrolled into view
        }

        ScrollTrigger.matchMedia({
            "(min-width: 769px)": function () {
                ScrollTrigger.create({
                    trigger: elem,
                    start: 'top 60%',
                    onEnter: function () { animateFrom(elem) },
                });

                ScrollTrigger.create({
                    trigger: elem,
                    end: 'bottom top',
                    onLeaveBack: function () { hide(elem) } // assure that the element is hidden when scrolled into view
                });
            },
            "(max-width: 768px)": function () {
                ScrollTrigger.saveStyles(".gs_reveal_fromLeft, .gs_reveal_fromRight, .gs_reveal");
            },
            "all": function () { }
        });
    });

    // Compteurs animés
    gsap.utils.toArray("[data-counter]").forEach(function(el) {
        ScrollTrigger.create({
            trigger: el,
            start: 'top 80%',
            once: true,
            onEnter: function() { animateCounter(el); }
        });
    });
});